import moment from 'moment';
import React, { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
import { Redirect } from 'react-router-dom';
import { DATE_FORMAT_URL } from '../../../../data/constants/datetime';
import { useItemsFilteredByDate } from "../../../../data/hooks/datetime/useItemsFilteredByDate";
import { useEvent } from '../../../../data/hooks/eventHooks';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import { useMeetings } from '../../../../data/hooks/meeting/useMeetings';
import { useMarkNotificationsRead } from '../../../../data/hooks/notifications/useMarkNotificationsRead';
import { useMeetingsNotifications } from '../../../../data/hooks/notifications/useMeetingsNotifications';
import { useMyUserId } from '../../../../data/hooks/sessionHooks';
import { eventMomentFactory } from '../../../../data/misc/eventMomentFactory';
import resolvePath from '../../../../misc/resolvePath';
import WaitWhileBusy from '../../../WaitWhileBusy';
import ListItem from '../../../elements/DEPRECATED_ListItem';
import Meeting from '../../../elements/Meeting';
import ScreenTitle from '../../../elements/ScreenTitle/ScreenTitle';
import ScrollableList from '../../../elements/ScrollableList';
import Tabs from '../../../elements/Tabs/old';
import ToolbarLayout from '../../../elements/ToolbarLayout';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import ErrorBoundary from '../../../validate/ErrorBoundary';
import Screen from '../../Screen';
import CommonMeetingsFooter from '../common/CommonMeetingsFooter';
import { useDatesFromItems } from '../../../../data/hooks/datetime/useDatesFromItems';

const EventMeetingsByDate = (props) => {
    const { eventId, date: dateUrl } = props,
        event = useEvent(eventId),
        i18n = useI18n(),
        date = eventMomentFactory(event, dateUrl, DATE_FORMAT_URL),
        allMeetings = useMeetings(eventId),
        dates = useDatesFromItems(event, allMeetings),
        todayMeetings = useItemsFilteredByDate(event, allMeetings, date),
        location = useLocation(),
        userId = useMyUserId(),
        notifications = useMeetingsNotifications(eventId),
        todayNotifications = useMemo(() => notifications.filter((notif) => todayMeetings.find((meeting) => meeting.id == notif?.content?.data?.meetingId && !notif.read)), [notifications]);

    useMarkNotificationsRead(todayNotifications);

    const handleDateSelectionChange = useCallback((date) => {
        app.history.replace(['/events', eventId, 'meetings', date.format(DATE_FORMAT_URL)].join('/'));
    }, []);

    if (!dates.length) return <Redirect to={resolvePath(location.pathname, '..')} />;

    const header = (
            <div>
                <TopBarEvent event={event} meetings="meetings" returnURL={'../..'} />
                <hr />
                <ScreenTitle screen={i18n['label.event.title']} event={event} timezone />
                <ToolbarLayout>
                    <Tabs selectedTabStyle={event._local.styles.button_secondary} minTabWidth={120}>
                        {dates
                            .map((d) => moment(d))
                            .map((d) => (
                                <button type="button" selected={d.isSame(date, 'day')} onClick={() => handleDateSelectionChange(d)} key={d}>
                                    {d.format('D MMMM')}
                                </button>
                            ))}
                    </Tabs>
                </ToolbarLayout>
            </div>
        ),
        footer = <CommonMeetingsFooter event={event} i18n={i18n} />;

    return (
        <Screen header={header} footer={footer}>
            <ScrollableList className="content unmargin-right" savePosition={'eventMeetings-' + eventId}>
                {todayMeetings.map((meeting) => {
                    if (meeting.blocked) {
                        return null;
                    }
                    return (
                        <ListItem key={meeting.id}>
                            <Meeting event={event} meeting={meeting} i18n={i18n} userId={userId} />
                        </ListItem>
                    );
                })}
            </ScrollableList>
        </Screen>
    );
};

export default (props) => (
    <ErrorBoundary altRoute="../..">
        <WaitWhileBusy>
            <EventMeetingsByDate {...props.match.params} date={props.match.params.meetingTab} />
        </WaitWhileBusy>
    </ErrorBoundary>
);
